<script lang="ts" setup>
import { computed } from 'vue'

import Icons from './glyphs/icons'
import { IconSize } from './helpers'
import type { TIconName, TIconSize } from './types'

const props = withDefaults(
  defineProps<{
    /**
     * The name of the icon to show.
     */
    name: TIconName
    /**
     * Controls the size of the icon
     */
    size?: TIconSize
  }>(),
  {
    size: IconSize.Medium,
  }
)

const IconComponent = computed(() => (props.name ? Icons[props.name] : null))
</script>
<template>
  <component :is="IconComponent" aria-hidden="true" class="glp-icon" />
</template>

<style>
.glp-icon {
  width: var(--glp-icon-size, 20px);
  height: var(--glp-icon-size, 20px);
}
</style>
